import { Builder } from '@builder.io/react';
import { useEffect, useState } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import donorImg from '../../../../../../images/home/donor-image.png';
import ShowCurrencies from '../../../../../../utils/showCurrencies';
import moment from 'moment';
import Skeleton from 'react-loading-skeleton';
import AutoplayPlugin from '../../../../../../pages/MATWAppeal/components/autoplayPlugin';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectSelectedCurrency } from '../../../../../../store/user';
import services from '../../../../../../services';

const AppealDonors = props => {
  /* ----------------------------- Start variables ---------------------------- */
  const { appealsProducts } = props;
  const [loaded, setLoaded] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const { i18n } = useTranslation();
  const selectedCurrencyStore = useSelector(selectSelectedCurrency);
  const lang = i18n.language;
  const [donors, setDonors] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  const [sliderRef, instanceRef] = useKeenSlider(
    {
      // mode: "snap",
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      },
      loop: true,
      breakpoints: {
        '(min-width: 320px)': {
          // slidesPerView: 1,
          // spacing: 5,
          slides: { perView: 1, spacing: 5 },
        },
        '(min-width: 768px)': {
          // slidesPerView: 3,
          // spacing: 5,
          slides: { perView: 3, spacing: 5 },
        },
        '(min-width: 992px)': {
          // slidesPerView: 5,
          // spacing: 10,
          // origin: "center"
          slides: { perView: 5, spacing: 10, origin: 'center' },
        },
        '(min-width: 1280px)': {
          // slidesPerView: 7,
          // spacing: 10,
          // origin: "center"
          slides: { perView: 7, spacing: 10, origin: 'center' },
        },
      },
      slides: {
        origin: 'center',
      },
    },
    [
      AutoplayPlugin(2000), // Initialize AutoplayPlugin with 2-second interval
    ],
  );
  /* -------------------------------------------------------------------------- */
  /* -------------------------------------------------------------------------- */

  /* ------------------------------ Start methods ----------------------------- */
  const getDonors = async () => {
    let req = {
      products: appealsProducts.map(item => item.creator),
      limit: 50,
      currency: selectedCurrencyStore,
      start_date: new Date(new Date().setDate(new Date().getDate() - 30)), // Fetch donors from the last 30 days
    };
    try {
      const response = await services.getLatestDonors(req);
      setDonors(response.data);
    } catch (error) {
      console.error('error========', error);
    }
  };
  const handleDonateTime = value => {
    var now = moment(new Date()); //todays date
    var end = moment(value); // another date
    var duration = moment.duration(now.diff(end));
    var days = duration.asMinutes();
    var timeDifference = Math.abs(days);
    let time = '';
    if (timeDifference < 60) {
      time = `${Math.round(timeDifference)} minutes ago`;
    } else if (timeDifference < 1440) {
      time = `${Math.round(timeDifference / 60)} hours ago`;
    } else if (timeDifference < 10080) {
      time = `${Math.round(timeDifference / 1440)} days ago`;
    } else if (timeDifference > 10079) {
      time = `${Math.round(timeDifference / 10080)} weeks ago`;
    }
    return time;
  };
  /* -------------------------------------------------------------------------- */
  /* ------------------------------- Start hooks ------------------------------ */
  // Add useEffect to handle dynamic donors
  useEffect(() => {
    if (instanceRef.current) {
      instanceRef.current.update(); // Notify KeenSlider to update
    }
  }, [donors, instanceRef]);
  useEffect(() => {
    selectedCurrencyStore && getDonors(selectedCurrencyStore);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCurrencyStore]);
  /* -------------------------------------------------------------------------- */
  return (
    <section className={`bg-[#F5F5F5] px-4 py-2 md:py-4`}>
      <div className={`w-full justify-center items-center flex flex-col pb-2 md:pb-4`}>
        <h2 className={`text-DarkerBlue font-brandingBold text-lg md:text-3xl`}>Donors</h2>
        <p
          className={`mt-2 md:mt-4 text-[#78716C] leading-7 md:text-[18px] space-y-4 ${
            lang === 'ar' ? 'font-[AlmariMedium]' : 'font-brandingMedium'
          }`}
        >
          Recent Supporters
        </p>
      </div>
      <div className="w-full hidden sm:flex flex-wrap justify-center items-center relative">
        <div ref={sliderRef} className="keen-slider py-3">
          {donors && donors.map((item, index) => {
            return (
              <div key={`active_carousel_${index}`} className="keen-slider__slide basis-full flex justify-center">
                <div className="w-full max-w-[300px] bg-white rounded-md shadow-md p-4 flex justify-start items-center">
                  <div className="flex justify-center items-center w-12 h-12 rounded-full">
                    <img className="w-full rounded-full" src={donorImg} alt="" />
                  </div>
                  <div className="flex flex-col pl-2 md:pl-3">
                    <h2 className="text-sm md:text-base text-DarkerBlue font-brandingBold">{item ? item.donor_name : <Skeleton height={24} />}</h2>
                    <p className={`text-[#78716C] text-xs md:text-sm ${lang === 'ar' ? 'font-[AlmariMedium]' : 'font-brandingMedium'}`}>
                      {item ? (
                        <>
                          {ShowCurrencies(selectedCurrencyStore, Math.round(item.amount), true)} {handleDonateTime(item.created_at)}
                        </>
                      ) : (
                        <Skeleton height={21} />
                      )}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {donors.length > 1 && (
          <div className="flex sm:hidden bg-white py-3 px-2 rounded-md justify-center items-center mx-auto mt-2 max-w-[300px]">
            {loaded && instanceRef.current && (
              <div className="flex justify-center items-center relative w-full">
                {[...Array(instanceRef.current.track.details.slides.length).keys()].map(idx => {
                  return (
                    <button
                      key={`q${idx}`}
                      onClick={() => {
                        instanceRef.current?.moveToIdx(idx);
                      }}
                      className={
                        'md:w-4 md:mx-2 mx-1 md:h-4 h-3  w-3 rounded-full ' +
                        (currentSlide === idx ? ' bg-LightBlue hover:opacity-60' : 'bg-[#C3C3C3]')
                      }
                    ></button>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </div>
      <div className="w-full flex flex-col sm:hidden justify-center relative">
        {donors.map((item, index) => {
          return (
            <div key={`carousel_${index}`} className="w-full mb-1 bg-white rounded-md shadow-md p-4 flex justify-start items-center">
              <div className="flex justify-center items-center w-12 h-12 rounded-full">
                <img className="w-full rounded-full" src={donorImg} alt="" />
              </div>
              <div className="w-full flex justify-between items-center">
                <div className="flex flex-col pl-2 md:pl-3">
                  <h2 className="text-sm md:text-base text-DarkerBlue font-brandingBold">{item ? item.donor_name : <Skeleton height={24} />}</h2>
                  <p className={`text-[#78716C] text-xs md:text-sm ${lang === 'ar' ? 'font-[AlmariMedium]' : 'font-brandingMedium'}`}>
                    {item ? <>{handleDonateTime(item.created_at)}</> : <Skeleton height={21} />}
                  </p>
                </div>
                <p className={`text-[#78716C] text-sm md:text-md ${lang === 'ar' ? 'font-[AlmariMedium]' : 'font-brandingMedium'}`}>
                  {item ? <>{ShowCurrencies(selectedCurrencyStore, Math.round(item.amount), true)}</> : <Skeleton height={21} />}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

Builder.registerComponent(AppealDonors, {
  name: 'AppealDonors',
  inputs: [
    {
      name: 'appealsProducts',
      type: 'array',
      subFields: [
        {
          name: 'creator',
          type: 'string',
        },
      ],
    },
  ],
});

export default AppealDonors;
